import { type StyleProp, type ViewStyle } from 'react-native-web';

import { CustomButton } from '@rivallapp/volosports-components';
import styles from '../styles';

interface PopFilterButtonProps {
  label: string;
  onPress: () => void;
  pressed: boolean;
  style?: StyleProp<ViewStyle>;
}

const PopFilterButton = ({ label, onPress, pressed, style }: PopFilterButtonProps) => (
  <CustomButton
    thin
    label={label}
    variant="outline"
    pressed={pressed}
    onPress={onPress}
    textStyle={{ fontSize: 12 }}
    style={[styles.button, style]}
  />
);

export default PopFilterButton;
